var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SidebarNavItem',{attrs:{"text":_vm.$t('dictionary.logout'),"level":1,"has-separator":false,"icon-src":_vm.$options.locals.logoutIcon,"icon-alt-text":_vm.$t('dictionary.logout')},on:{"click":_vm.signOut}})}
var staticRenderFns = []

export { render, staticRenderFns }